/*
 * Module for the SPC Estimate page
*/
rs.module("ui/content/benefits/estimates/permissiveoptions",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors, spcTypes) {

            // Unpack Js Selectors
            var selectedCostOptionRadio = $.js(jsSelectors.selectedCostOptionRadio, { required: false, multiple: true });
            var paginationContainer = $.js(jsSelectors.permissivePagination, { required: false });

            selectedCostOptionRadio.change(function () {
                // Remove highlight from all rows
                selectedCostOptionRadio.closest('tr').removeClass('selected-row');

                // Add highlight to this one
                $(this).closest('tr').addClass('selected-row');
            });


            // --- Pagination setup ---
            var rows = $('.permissive-table tbody tr');
            var pageSize = 10;
            var pageCount = Math.ceil(rows.length / pageSize);
            var currentPage = 1;

            if (!rows.length || !paginationContainer.length || pageCount <= 1) {
                // Nothing to paginate
                return;
            }

            function showPage(page) {
                currentPage = page;
                rows.hide();

                var start = (page - 1) * pageSize;
                var end = start + pageSize;

                rows.slice(start, end).show();

                // Update active button
                paginationContainer.find('button[data-page]')
                    .removeClass('active');
                paginationContainer.find('button[data-page="' + page + '"]')
                    .addClass('active');
            }

            function buildPager() {
                var html = '<div class="btn-group">';

                html += '<button type="button" class="btn btn-sm btn-secondary" data-nav="prev">&laquo;</button>';

                for (var i = 1; i <= pageCount; i++) {
                    html += '<button type="button" class="btn btn-sm btn-outline-secondary" data-page="' + i + '">' + i + '</button>';
                }

                html += '<button type="button" class="btn btn-sm btn-secondary" data-nav="next">&raquo;</button>';

                html += '</div>';

                paginationContainer.html(html);

                // Page number click
                paginationContainer.on('click', 'button[data-page]', function () {
                    var page = parseInt($(this).attr('data-page'), 10);
                    showPage(page);
                });

                // Prev/Next
                paginationContainer.on('click', 'button[data-nav]', function () {
                    var nav = $(this).attr('data-nav');
                    if (nav === 'prev' && currentPage > 1) {
                        showPage(currentPage - 1);
                    } else if (nav === 'next' && currentPage < pageCount) {
                        showPage(currentPage + 1);
                    }
                });
            }

            buildPager();
            showPage(1);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
